import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import '../styles/App.css';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { withRouter }       from 'react-router';
import Home from './components/home.js';
import Info from './components/info.js';
import News from './components/news.js';
import Post from './components/post.js';
import Terms from './components/terms.js';
import Project from './components/project.js';

const TheApp = withRouter(({ location }) => (
  <div className="App">
    <TransitionGroup>
      <CSSTransition
        key={location.key}
        classNames='fade'  //curtains
        timeout={{
          enter: 1400, // enter: (window.innerWidth < 600 ? 700 : 700),
          exit: 600 // exit: (window.innerWidth < 600 ? 400 : 400)
        }}
        onExited={()=>{window.scrollTo(0, 0)}}
      >
        <Switch location={location}>
          <Route exact path='/' component={Home} />
          <Route exact path='/projects/:slug' component={Project} />
          <Route exact path='/info' component={Info} />
          <Route exact path='/news' component={News} />
          <Route exact path='/news/:slug' component={Post} />
          <Route exact path='/privacy-statement' component={Terms} />
        </Switch>
      </CSSTransition>
    </TransitionGroup>
  </div>
));

class App extends Component {
  constructor(props) {
    super(props);
    const ld = document.querySelector('#loader');
    ld.classList.add('done');
  }

  render() {
    return (
      <TheApp />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/scripts/App.js